import React from 'react';
import { FlexLayout, LayoutJustification } from '~/graphql/types';
import JustificationContainer, {
  Justification,
} from '~/components/atom/JustificationContainer';
import styled, { css } from 'styled-components';
import { BLUR_STYLES } from '../../Data/styles';
import layoutSizeToSystemSize from '~/components/template/EventTimelineV2/utils/layoutSizeToSystemSize';

export type Props = Omit<FlexLayout, '__typename'> & {
  dataTestId?: string;
  blurred?: boolean | null;
};

const Flex: React.FCC<Props> = ({
  children,
  css,
  padding,
  margin,
  justification,
  align,
  gap,
  direction,
  blurred,
}) => (
  <Container
    padding={padding?.map(layoutSizeToSystemSize) ?? ['base']}
    margin={margin?.map(layoutSizeToSystemSize) ?? undefined}
    justification={convertToFrontendType(justification)}
    align={convertToFrontendType(align)}
    gap={gap ?? undefined}
    direction={direction ?? undefined}
    wrap="wrap"
    $css={css}
    $blurred={blurred || false}
  >
    {children}
  </Container>
);

const convertToFrontendType = (
  justification?: LayoutJustification | null,
): Justification => {
  switch (justification) {
    case LayoutJustification.Start:
      return 'start';
    case LayoutJustification.End:
      return 'end';
    case LayoutJustification.Center:
      return 'center';
    case LayoutJustification.SpaceBetween:
      return 'space-between';
    case LayoutJustification.SpaceAround:
      return 'space-around';
    case LayoutJustification.Stretch:
      return 'stretch';

    default:
      return 'start';
  }
};

const Container = styled(JustificationContainer)<{
  $blurred: boolean;
  $css?: string | null;
}>(
  ({ $blurred, $css }) => css`
    ${$blurred && BLUR_STYLES};

    ${$css &&
    css`
      ${$css}
    `}
  `,
);

export default Flex;
